import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit4-conclusion',
  templateUrl: './unit4-conclusion.component.html',
  styleUrls: ['./unit4-conclusion.component.css']
})
export class Unit4ConclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
